import React, { useState } from "react"
import { twMerge } from "tailwind-merge"

const ExpandableDescription = ({ content, maxLines = 4, theme, title = "Details", className, charLimit = 300 }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  // Support both v1 and v2 theme structures
  // Note: This component doesn't have access to practice prop, so we use theme directly
  const textDarkColor = theme?.colors?.textDark || theme?.colorTextDark
  const headingFont = theme?.fonts?.heading || theme?.fontHeading

  // Strip HTML tags and count actual text characters
  const textContent = content.replace(/<[^>]*>/g, "").trim()
  const shouldShowToggle = textContent.length > charLimit

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  // Map maxLines to corresponding Tailwind classes
  const getLineClampClass = (lines) => {
    const clampClasses = {
      1: "line-clamp-1",
      2: "line-clamp-2",
      3: "line-clamp-3",
      4: "line-clamp-4",
      5: "line-clamp-5",
      6: "line-clamp-6"
    }
    return clampClasses[lines] || "line-clamp-3"
  }

  return (
    <div className={twMerge("", className)}>
      <h3 className="mb-4 text-2xl font-bold" style={{ color: textDarkColor, fontFamily: headingFont }}>
        {title}
      </h3>
      <div
        className={twMerge(
          "wysiwyg-content transition-all duration-300",
          !isExpanded && shouldShowToggle ? getLineClampClass(maxLines) : ""
        )}
        style={{ color: textDarkColor }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {shouldShowToggle && (
        <button
          onClick={toggleExpanded}
          className="mt-3 text-sm font-semibold underline transition-colors duration-150 hover:opacity-75"
          style={{ color: textDarkColor }}>
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  )
}

export default ExpandableDescription
